import _ from 'lodash'

export const state = {
  snackbarConfigs: []
}

export const mutations = {
  ['ADD_SNACKBAR_CONFIG'](state, configs) {
    state.snackbarConfigs = _.concat(state.snackbarConfigs, configs)
  },
  ['REMOVE_FIRST_SNACKBAR_CONFIG'](state) {
    state.snackbarConfigs.shift()
  }
}

export const actions = {
  async ['ADD_SNACKBAR_CONFIG']({ commit }, configs) {
    commit('ADD_SNACKBAR_CONFIG', configs)
  },
  async ['REMOVE_FIRST_SNACKBAR_CONFIG']({ commit }) {
    commit('REMOVE_FIRST_SNACKBAR_CONFIG')
  }
}

export const getters = {}
